import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    const modalId = event.currentTarget.dataset.modalTarget
    const modal = document.getElementById(`${modalId}-modal`)
    if (modal) {
      modal.classList.remove("hidden")
      document.body.classList.add("overflow-hidden")
    }
  }

  close() {
    const modal = this.element.closest("[id$='-modal']") || this.element
    modal.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  closeOnClickOutside(event) {
    if (event.target === this.element) {
      this.close()
    }
  }
}
